import Swiper from 'swiper'
import { A11y, Autoplay, Navigation } from 'swiper/modules'

export default class Sliders {
  constructor(slider, index) {
    this.slider = slider
    this.index = index
    this.slides = Array.from(this.slider.querySelectorAll('.swiper-slide'))

    this.options = this.setOptions()
    this.initSlider()
  }

  setOptions() {
    let options = {}

    if (this.slider.classList.contains('swiper--brand-architecture')) {
      options = {
        modules: [A11y, Autoplay],
        allowTouchMove: false,
        spaceBetween: 20,
        height: 100,
        updateOnWindowResize: true,
        watchOverflow: true,
        centeredSlides: true,
        loop: true,
        slidesPerView: 3.5,
        speed: 4000,
        autoplay: {
          delay: 0,
          pauseOnMouseEnter: false,
          disableOnInteraction: false,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2.5,
          },
          1024: {
            slidesPerView: 3.5,
          }
        },
        a11y: {
          enabled: true,
          containerRole: 'region',
          containerRoleDescriptionMessage: 'carousel',
          containerMessage: 'Experience carousel',
          prevSlideMessage: 'Slide precedente',
          nextSlideMessage: 'Slide successiva',
          paginationBulletMessage: 'Vai alla slide {{index}}',
          itemRoleDescriptionMessage: 'slide',
        },
      }
    }

    return options
  }

  initSlider() {
    console.debug('  -> Sliders init')
    let swiperInstance = new Swiper(this.slider, this.options)

    swiperInstance.init()
    this.swiperInstance = swiperInstance
  }

  destroy() {
    console.debug('  -> Sliders destroy')
    this.swiperInstance.destroy()
  }

  static destroyAll() {
    console.debug('  -> Sliders destroy all')
    Sliders.items.forEach((slider) => {
      slider.destroy()
    })
  }

  static init() {
    console.debug('== Sliders components ==')
    Sliders.items = Array.from(document.querySelectorAll('.swiper')).map(
      (slider, index) => new Sliders(slider, index)
    )
  }


}